


























































































































































import _ from 'lodash';
import Fuse from 'fuse.js';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Debounce } from '@/decorators';
import { Action, Getter } from 'vuex-class';
import { mapActions, mapGetters } from 'vuex';
import { IOrderDetails, IProduct, isProduct, Product } from '@/service/types';
import {
  IParamUpdateQuantity,
  IValidationWrappedProductDict,
  IValidationProcess,
  ValidationStatus,
  MessageType,
  IOrderValidationMessage,
  IParamUpdateValidationProduct
} from '@/store/types';

// Components
import Spinner from '@/components/ui/Spinner.vue';
import OrderDetailsProduct from './OrderDetailsProduct.vue';
import OrderDetailsDialog from './OrderDetailsDialog.vue';

// import { Howl } from 'howler';

// const popSound = new Howl({
//   src: ['/sounds/pop.wav']
// });

// it cannot be used because tslint do not understand spread operator
interface IProductExtended extends IProduct {
  scannedQuantity: number,
  ValidationStatus: ValidationStatus,
  mappedState: string,
  message?: string
}

const stateByMapDefault = 'info';
const stateByMap: {[k:number]: string} = {}
stateByMap[_.toNumber(ValidationStatus.Ok)] = 'success';
stateByMap[_.toNumber(ValidationStatus.TooFew)] = 'error';
stateByMap[_.toNumber(ValidationStatus.TooMuch)] = 'error';
stateByMap[_.toNumber(ValidationStatus.Extraneous)] = 'error';
stateByMap[_.toNumber(ValidationStatus.OtherError)] = 'error';

const getTypeByState = function(state: ValidationStatus) {
  return _.get(stateByMap, _.toNumber(state), stateByMapDefault);
}

const alertTypeMapDefault = 'info';
const alertTypeMap: {[k:number]: string} = {}

alertTypeMap[_.toNumber(MessageType.Success)] = 'success';
alertTypeMap[_.toNumber(MessageType.Info)] = 'info';
alertTypeMap[_.toNumber(MessageType.Warning)] = 'warning';
alertTypeMap[_.toNumber(MessageType.Danger)] = 'error';

const getAlertTypeByMap = function(state: MessageType) {
  return _.get(alertTypeMap, _.toNumber(state), stateByMapDefault);
}

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({
  components: {
    OrderDetailsProduct,
    OrderDetailsDialog,
    Spinner
  }
})
export default class OrderDetails extends Vue {
  dialogCancel: boolean = false;
  dialogReject: boolean = false;
  dialogConfirm: boolean = false;
  synchronizing: boolean = false;
  finished: boolean = false;
  enqueuedRoutePush: Function = () => {};
  
  @Action('product/fetchToOtherByEan') async fetchToOtherByEan(ean: string) {};
  @Action('order/updateValidationProduct') async updateValidationProduct(params: IParamUpdateValidationProduct) {};
  @Action('order/updateOrders') async sync(force: boolean) {};
  @Action('order/cancel') async cancel(id: number) {};
  @Action('order/reject') async reject(id: number): Promise<boolean> { return new Promise(() => true); };
  @Action('order/confirm') async confirm(id: number): Promise<boolean> { return new Promise(() => true); };
  @Action('order/updateQty') updateQty(params: IParamUpdateQuantity) {};
  @Getter('order/oneComposed') getFromStorage: (id: number) => IOrderDetails;
  @Getter('order/validationProcess') processForOrder: (idOrder: number) => IValidationProcess;
  @Getter('getScannerValue') scannerValue: string;
  @Getter('getScanIndex') scanIndex: string;
  @Getter('product/getByEan') getByEan: (ean: string) => IProduct|boolean;
  @Getter('product/getFromOtherByEan') getFromOtherByEan: (ean: string) => IProduct|boolean;
  @Watch('scanIndex') watchScannerValue(value: string, oldValue: string) {
    const scannerValue = this.scannerValue;
    const options = {
      threshold: 0,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: [
        "ean"
      ]
    };
    const searchOperation = new Fuse(this.normalProducts, options);
    let hits = searchOperation.search(scannerValue);
    // popSound.play();
    let qty, product;
    if (_.get(hits, 'length', 0)) {
      product = _.first(hits);
      let index = _.get(product, 'id');
      qty = _.get(product, 'scannedQuantity', 0);
      this.updateQty({
        orderId: this.orderId,
        productIndex: index,
        quantity: qty + 1
      });
    } else {
      product = this.getByEan(scannerValue);
      let found = isProduct(product);
      let all = _.toPlainObject(this.products);
      qty = _.get(
        all,
        `${found ? _.get(product, 'id') : scannerValue}.validation.quantity`, 
        0
      );
      if (!qty) {
        qty = 0;
      }
      if (isProduct(product)) {
        this.updateQty({
          orderId: this.orderId,
          productIndex: _.get(product, 'id'),
          quantity: qty + 1,
          product
        });
      } else {
        const otherProduct = this.getFromOtherByEan(scannerValue);

        this.updateQty({
          orderId: this.orderId,
          productIndex: isProduct(otherProduct) ? _.get(otherProduct, 'id') : scannerValue,
          quantity: qty + 1,
          product: (isProduct(otherProduct) ? otherProduct : (new Product({
            name: this.$t('dashboard.orderDetails.messages.unknownWith') + ": " + scannerValue,
            index: this.$t('dashboard.orderDetails.messages.unknown'),
            color: this.$t('dashboard.orderDetails.messages.unknown'),
            size: this.$t('dashboard.orderDetails.messages.unknown'),
            id: scannerValue,
            ean: scannerValue,
          })))
        });

        if (!isProduct(otherProduct)) {
          this.fetchToOtherByEan(scannerValue)
            .then((retrievedProduct) => {
              if (isProduct(retrievedProduct)) {
                // @ts-ignore
                const cloned: IProduct = _.cloneDeep(retrievedProduct);
                cloned.id = cloned.ean;
                this.updateValidationProduct({
                  orderId: this.orderId,
                  productEan: scannerValue,
                  // @ts-ignore
                  product: cloned,
                });
              }
            });
        }
      }
    }
  }

  get notFound() {
    return !this.order;
  }

  get isEmpty() {
    return !_.get(this.normalProducts, 'length', 0);
  }

  get orderId(): number {
    return _.get(this.$router, 'currentRoute.params.orderId', 0);
  }

  get order(): IOrderDetails|null {
    return this.getFromStorage(this.orderId);
  }

  get process(): IValidationProcess {
    return this.processForOrder(this.orderId);
  }

  get products(): IValidationWrappedProductDict {
    return this.process.products;
  }

  get messages() {
    return _.map(this.process.generalMessages, (item: IOrderValidationMessage) => {
      let cl: any = _.cloneDeep(item);
      cl.type = getAlertTypeByMap(cl.type);
      return cl;
    });
  }

  get normalProducts() {
    return _.map(
      _.filter(this.products, (filteredItem) => {
        return filteredItem.state !== ValidationStatus.Extraneous;
      }),
      (map) => {
        return {
          ...(map.product),
          scannedQuantity: _.get(map.validation, 'quantity', 0),
          ValidationStatus: map.state,
          mappedState: getTypeByState(map.state)
        };
      }
    );
  }

  get redundantProducts() {
    return _.flatten(
      _.map(
        _.filter(this.products, (filteredItem): boolean => {
          return ( 
            filteredItem.state === ValidationStatus.Extraneous 
            || 
            filteredItem.state === ValidationStatus.TooMuch
          );
        }),
        (map) => {
          let scannedQuantity = _.get(map.validation, 'quantity', 0);
          let qty = _.get(map.product, 'quantity', 0);
          let ret = [];
          let message;
          let diff;
          if (map.state === ValidationStatus.TooMuch) {
            message = this.$t('dashboard.orderDetails.messages.tooMuch');
            diff = scannedQuantity - qty;
          } else {
            message = this.$t('dashboard.orderDetails.messages.notOrdered');
            diff = scannedQuantity;
          }    
          
          for (let i = 0; i < diff; i++) {
            ret.push({
              ...(map.product),
              scannedQuantity: scannedQuantity,
              ValidationStatus: map.state,
              mappedState: getTypeByState(map.state),
              message
            });
          }
          // } else {
          //   ret.push({
          //     ...(map.product),
          //     scannedQuantity: scannedQuantity,
          //     ValidationStatus: map.state,
          //     mappedState: getTypeByState(map.state),
          //     message: this.$t('dashboard.orderDetails.messages.notOrdered')
          //   })
          // }
          return ret;
        }
      )
    );
  }

  // Events:
  async onSync() {
    this.synchronizing = true;
    try {
      await this.sync(true);
    } catch (e) {
      console.log(e);
    } finally {
      this.synchronizing = false;
    }
  }

  up(index: string, quantity: number) {
    this.updateQty({
      orderId: this.orderId,
      productIndex: index,
      quantity: quantity + 1
    });
  }

  down(index: string, quantity: number) {
    if (quantity < 1){
      return;
    }
    this.updateQty({
      orderId: this.orderId,
      productIndex: index,
      quantity: quantity - 1
    });
  }

  requestReject() {
    this.dialogReject = true;
  }

  async rejectResponse(yes: boolean) {
    this.dialogReject = false;
    if (yes) {
      try {
        let result: boolean = await this.reject(this.orderId);
        if (result) {
          this.finished = true;
          this.$router.push({name: 'dashboard-orders'})
        }
      } catch(reason) {
        console.log(reason);
      }
    } else {
      this.enqueuedRoutePush = () => {};
    }
  }

  async requestConfirm() {
    let result: boolean = await this.confirm(this.orderId);
    if (result) {
      this.dialogConfirm = true;
    }
  }

  @Debounce(250) confirmResponse() {
    console.log('dismissed');
    this.dialogConfirm = false;
    this.finished = true;
    this.$router.push({name: 'dashboard-orders'})
  }

  cancelResponse(yes: boolean) {
    this.dialogCancel = false;
    if (yes) {
      this.cancel(this.orderId);
      this.enqueuedRoutePush();
    } else {
      this.enqueuedRoutePush = () => {};
    }
  }

  beforeRouteLeave (to: any, from: any, next: Function) {
    if (!this.finished && !this.isEmpty) {
      this.dialogCancel = true;
      this.enqueuedRoutePush = next;
      return;
    }
    next();
  }

  backToDashboard() {
    this.$router.push({name: 'dashboard-orders'});
  }

  // breakpoints
  get isCompact() {
    return !this.$vuetify.breakpoint.xl;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.smAndDown;
  }
}
